export enum ColumnGroupTypes {
  groupBy = 1,
  groupByMany = 2
}

export const COLUMN_GROUP_TYPES = [
  { value: ColumnGroupTypes.groupBy, label: 'Singolo' },
  { value: ColumnGroupTypes.groupByMany, label: 'Gerarchico' }
];
